import { render } from "./Careers.vue?vue&type=template&id=2f07aa42&scoped=true"
import script from "./Careers.vue?vue&type=script&lang=js"
export * from "./Careers.vue?vue&type=script&lang=js"

import "./Careers.vue?vue&type=style&index=0&id=2f07aa42&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/kurdos-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f07aa42"]])

export default __exports__